import { UserStatuses } from '../enums/user-statuses.enum';

// Disabled Referral in ticket S20-1132
export const isAllowedReferralHelper = (status: UserStatuses, isPartner: boolean): boolean =>
  // !isPartner && [UserStatuses.WIX_USER, UserStatuses.SUBSCRIBER, UserStatuses.PENDING_CANCELLATION].includes(status);
  false;
